import { SIDEBAR_KEY } from '../../utils/localStorageKeys'

function sidebarState() {
  return {
    isOpened: localStorage.getItem(SIDEBAR_KEY) || true,
    isAnimated: true,
  }
}

export default sidebarState
